/**
 * 代码高亮
 */
import type { DirectiveBinding } from 'vue'
import { type HLJSApi } from 'highlight.js'
import 'highlight.js/styles/default.css'

let hljs: HLJSApi
async function highlight(el: HTMLElement, binding: DirectiveBinding) {
  if(!hljs) {
    hljs = (await import('highlight.js')).default
  }
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block: any) => {
    // 清除之前的高亮状态
    if (block.dataset.highlighted === 'yes') {
      block.textContent = block.textContent
      block.removeAttribute('data-highlighted')
    }
    // 应用高亮
    hljs.highlightElement(block)
  })
}

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    highlight(el, binding)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    highlight(el, binding)
  }
}